<div *ngIf="currentScreen === DBC_ONBOARD_V2_SCREENS.ONBOARDING_FORM">
    <div>
        <div class="sticky-top top-bar">
            <img class="uniqode-img" src="assets/img/uniqode-header-logo-dark.png" alt="uniqode">
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center px-4">
            <div class="onboard-title text-center">{{titleText}}</div>
            <div class="onboard-description text-center">{{descriptionText}}</div>
        </div>

        <app-form-layout-one
                              [dbc]="dbc"
                              [userImageUrl]="userImageUrl"
                              [logoUrl]="logoUrl"
                              (formUpdated)="handleFormUpdated($event)"
                              (imageSelected)="handleImageSelected($event)"
                              [isFirstNameMissing]="isFirstNameMissing"
                              [colorOptions]="colorOptions"
                              [fullPhoneNumber]="fullPhoneNumber"
                              [phoneNumber]="phoneNumber"
                              [countryNameCode]="countryNameCode"
                              (onCountryFlagChange)="countryFlagChange($event)"
                              [isInvalidEmail]="isInvalidEmail"
                              [defaultColorPickerBackground]="defaultColorPickerBackground"
                              [layoutPrimaryColor]="layoutPrimaryColor"
                              (openEditImageModal)="handleOpenEditImageModal($event)"
                              [emailInputErrorMessage]="emailInputErrorMessage"
                              (formCompleted)="onSave()">
        </app-form-layout-one>

        <!-- Save Button -->
        <div class="sticky-footer">
            <button class="save-btn" (click)="onSave()" *ngIf="!showSaveLoader">Save My Card</button>
            <button class="save-btn" *ngIf="showSaveLoader" [ngClass]="{'save-btn-clicked-state': showSaveLoader}"><spinner class="save-btn-spinner"></spinner></button>
        </div>
    </div>
</div>

<div *ngIf="false">
    <beaconstac-wait-loader></beaconstac-wait-loader>
</div>
